import { normalizeString } from './string-utils';

export function filterByFields<T>(
  items: T[],
  searchTerm: string,
  fields: (keyof T)[]
): T[] {
  if (!searchTerm) return [...items];

  const term = normalizeString(searchTerm);

  return items.filter((item) =>
    fields.some((field) =>
      normalizeString((item[field] as unknown as string) ?? '').includes(term)
    )
  );
}
